import { Text } from "@fluentui/react";
import { Settings24Regular } from "@fluentui/react-icons";

import styles from "./SettingsButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
    isDarkMode?: boolean;
}

export const SettingsButton = ({ className, onClick, isDarkMode }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""}`} onClick={onClick}>
            <Settings24Regular />
            <Text className={isDarkMode ? styles.textDark : styles.text}>{"Developer settings"}</Text>
        </div>
    );
};
